"use client";

import React, { useEffect, useMemo, useRef, useState } from "react";

import { motion } from "framer-motion";
import gsap from "gsap";
import styles from "./LeftCompNew.module.scss";
import FSTLOGO from "../../Components/assets/Images/firstockLogoBadge.svg";
import GooglePlayStore from "../../Components/assets/Images/GooglePlayStore.svg";
import AppStore from "../../Components/assets/Images/AppStore.svg";

/* ───────── Products carousel ─────────
 * Each product's accent matches the corresponding hero on
 * FirstockWebsite2.0 (Stocks → rose, MF → emerald, F&O → electric,
 * Terminal → gold, Charting → violet, Algos/Pricing → emerald,
 * Strategy Lab → rose).
 */
const PRODUCTS = ["Charting", "Automation", "Terminal", "Screener"];

const LeftCompNew: React.FC = () => {
  return (
    <div className={styles.mainWrapper}>
      {/* Backdrop: the frame's colour field, then the white wash that
          dissolves it into the form side of the split. */}
      <div className={styles.backdrop} aria-hidden="true" />
      <div className={styles.edgeFade} aria-hidden="true" />

      <div className={styles.companyLogo}>
        <img
          alt="Firstock"
          src={FSTLOGO}
          className={styles.logoBase}
          width={0}
          height={0}
        />
        <span className={styles.logoText}>Firstock</span>
      </div>

      <div className={styles.contentBlock}>
        <h1 className={styles.title}>
          <span className={styles.titleWords}>Building what</span>

          <span className={styles.accentWrap}>
            <em className={styles.accent}>matters</em>
            {/* A short red candle, then a taller green one reaching above it —
                the pair reads as growth, set at the height and weight of an
                apostrophe hung off the end of the word. */}
            <span className={styles.candles} aria-hidden="true">
              <svg width="22" height="26" viewBox="0 0 22 26" fill="none">
                <path
                  d="M5.5 9.5v14"
                  stroke="#e11d48"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                />
                <rect
                  x="2.5"
                  y="13"
                  width="6"
                  height="7.5"
                  rx="0.8"
                  fill="#e11d48"
                />
                <path
                  d="M16.5 2v21.5"
                  stroke="#0e9f6e"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                />
                <rect
                  x="13.5"
                  y="5.5"
                  width="6"
                  height="14"
                  rx="0.8"
                  fill="#0e9f6e"
                />
              </svg>
            </span>
          </span>
        </h1>

        {/* Products, one line of labels split by hairline dividers, closing on
            the per-order price. */}
        <p className={styles.markets}>
          {PRODUCTS.map((p, i) => (
            <React.Fragment key={p}>
              {i > 0 && <span className={styles.sep} aria-hidden="true" />}
              <span className={styles.market}>{p}</span>
            </React.Fragment>
          ))}
          <span className={styles.sep} aria-hidden="true" />
          <span className={`${styles.market} ${styles.price}`}>
            <svg
              className={styles.sparkle}
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M12 1.8c.85 6.3 3.9 9.35 10.2 10.2-6.3.85-9.35 3.9-10.2 10.2-.85-6.3-3.9-9.35-10.2-10.2C8.1 11.15 11.15 8.1 12 1.8Z"
                fill="#603CFF"
              />
            </svg>
            10 / order
          </span>
        </p>
      </div>

      <div className={styles.sidebarFooter}>
        <div className={styles.appsRow}>
          <a
            href="https://play.google.com/store/apps/details?id=in.firstock.mobile"
            target="_blank"
            rel="noreferrer"
          >
            <img
              alt="Get it on Google Play"
              src={GooglePlayStore}
              className={styles.appBadge}
            />
          </a>
          <a
            href="https://apps.apple.com/us/app/firstock-trade-invest/id6746480444"
            target="_blank"
            rel="noreferrer"
          >
            <img
              alt="Download on the App Store"
              src={AppStore}
              className={styles.appBadge}
            />
          </a>
        </div>

        <p className={styles.regText}>
          Firstock Broking (P) Ltd: NSE &amp; BSE - SEBI Registration No.
          INZ000260334 | CDSL - SEBI Registration No : IN-DP-67-2015 | Mutual
          Fund ARN: 132812
        </p>
      </div>
    </div>
  );
};

export default LeftCompNew;
